const dashboard = {
  user_dash_title: 'لوحة المستخدم',
  user_dash_profile: 'الملف الشخصي',
  user_dash_favorites: 'المفضلة',
  user_dash_consultations: 'الاستشارات',
  user_dash_compare: 'مقارنة',
  user_dash_recommendations: 'التوصيات',
  user_dash_diary: 'يومية العلاج',
  user_dash_notifications: 'الإشعارات',
  user_dash_contracts: 'العقود',
  user_dash_password: 'تغيير كلمة المرور',
  user_dash_logout: 'تسجيل الخروج',

  inst_dash_title: 'لوحة المؤسسة',
  inst_dash_overview: 'نظرة عامة',
  inst_dash_profile: 'ملف المؤسسة',
  inst_dash_appointments: 'إدارة المواعيد',
  inst_dash_analytics: 'التحليلات',
  inst_dash_membership: 'العضوية',
  inst_dash_contracts: 'العقود',
  inst_dash_reconciliation: 'التسوية',
  inst_dash_notifications: 'الإشعارات',
  inst_dash_logout: 'تسجيل الخروج',

  admin_dash_title: 'لوحة المشرف',
  admin_dash_overview: 'نظرة عامة',
  admin_dash_institutions: 'إدارة المؤسسات',
  admin_dash_users: 'إدارة المستخدمين',
  admin_dash_consultations: 'الاستشارات',
  admin_dash_contracts: 'إدارة العقود',
  admin_dash_packages: 'إدارة الباقات',
  admin_dash_stats: 'الإحصائيات',
  admin_dash_reports: 'التقارير',
  admin_dash_settings: 'الإعدادات',
  admin_dash_logout: 'تسجيل الخروج',

  user_dash_welcome: 'مرحباً، {{name}}',
  user_dash_tab_profile: 'الملف الشخصي والإشعارات',
  user_dash_tab_consultations: 'طلبات الاستشارة',
  user_dash_tab_contracts: 'عقودي',
  user_dash_tab_password: 'تغيير كلمة المرور',
  user_dash_loading: 'جار التحقق من الجلسة...',
  user_dash_remember_me: 'تذكرني',
  user_dash_back_to_login: 'العودة إلى صفحة تسجيل الدخول',
  user_dash_forgot_title: 'نسيت كلمة المرور',
  user_dash_forgot_desc: 'أدخل عنوان بريدك الإلكتروني المسجل وسنرسل لك رابط إعادة التعيين.',
  user_dash_forgot_send: 'إرسال رابط إعادة التعيين',
  user_dash_forgot_sending: 'جار الإرسال...',
  user_dash_forgot_sent_title: 'تم إرسال البريد الإلكتروني!',
  user_dash_forgot_sent_desc: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى <strong>{{email}}</strong>.',
  user_dash_forgot_spam: 'إذا لم تجد البريد الإلكتروني، تحقق من مجلد البريد العشوائي.',
  user_dash_back_to_login_btn: 'العودة إلى تسجيل الدخول',
  user_dash_login_title: 'دخول المستخدم',
  user_dash_login_desc: 'إدارة حسابك وعرض عقودك',
  user_dash_fill_all: 'يرجى ملء جميع الحقول',
  user_dash_login_failed: 'فشل تسجيل الدخول',
  user_dash_no_account: 'ليس لديك حساب؟',
  user_dash_register: 'إنشاء حساب',
  email_change_title: 'تغيير البريد الإلكتروني',
  email_change_subtitle: 'سيتم تحديث بيانات تسجيل الدخول',
  email_change_desc: 'أنت تغير عنوان بريدك الإلكتروني إلى <strong>{{email}}</strong>.',
  email_change_warning: 'بعد هذا التغيير، ستحتاج إلى تسجيل الدخول بـ <strong>عنوان بريدك الإلكتروني الجديد</strong>.',
  email_change_confirm: 'نعم، تحديث',
  email_change_saving: 'جار الحفظ...',
  email_change_cancel: 'إلغاء',
  profile_user_id: 'معرف المستخدم',
  profile_copy: 'نسخ',
  profile_copied: 'تم النسخ!',
  profile_title: 'معلومات الملف الشخصي',
  profile_saved: 'تم حفظ التغييرات.',
  profile_gender: 'الجنس',
  profile_male: 'ذكر',
  profile_female: 'أنثى',
  profile_other: 'أفضل عدم الإفصاح',
  profile_first_name: 'الاسم الأول',
  profile_last_name: 'اسم العائلة',
  profile_email: 'البريد الإلكتروني',
  profile_phone: 'الهاتف',
  profile_country: 'الدولة',
  profile_country_placeholder: 'اختر الدولة',
  profile_city: 'المدينة',
  profile_city_placeholder: 'اختر المدينة',
  profile_city_select_country: 'اختر الدولة أولاً',
  profile_search_country: 'البحث عن دولة...',
  profile_search_phone: 'البحث عن دولة أو رمز...',
  profile_no_result: 'لا توجد نتائج',
  profile_save_btn: 'حفظ التغييرات',
  notif_title: 'تفضيلات الإشعارات',
  notif_desc: 'اختر الإشعارات التي تريد تلقيها',
  notif_saved: 'تم حفظ تفضيلات الإشعارات.',
  notif_email_consult: 'إشعار بريد إلكتروني لطلب الاستشارة',
  notif_email_consult_desc: 'تلقي بريد إلكتروني عند تغيير حالة الطلب',
  notif_email_newsletter: 'رسائل النشرة الإخبارية',
  notif_email_newsletter_desc: 'ابق على اطلاع بتطورات السياحة الصحية',
  notif_sms_consult: 'إشعار SMS',
  notif_sms_consult_desc: 'تلقي رسالة SMS عند الموافقة على طلب الاستشارة',
  notif_sms_reminder: 'إشعارات التذكير',
  notif_sms_reminder_desc: 'تلقي تذكير قبل الاستشارة',
  notif_save_btn: 'حفظ التفضيلات',
  pwd_title: 'تغيير كلمة المرور',
  pwd_saved: 'تم تغيير كلمة المرور بنجاح.',
  pwd_current: 'كلمة المرور الحالية',
  pwd_new: 'كلمة المرور الجديدة',
  pwd_new_placeholder: '6 أحرف على الأقل',
  pwd_confirm: 'تأكيد كلمة المرور الجديدة',
  pwd_confirm_placeholder: 'أعد إدخال كلمة المرور',
  pwd_mismatch: 'كلمات المرور غير متطابقة',
  pwd_submit: 'تغيير كلمة المرور',
  pwd_verifying: 'جار التحقق...',
  pwd_strength_weak: 'ضعيف',
  pwd_strength_medium: 'متوسط',
  pwd_strength_strong: 'قوي',
  pwd_err_current: 'أدخل كلمة المرور الحالية',
  pwd_err_min: 'يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل',
  pwd_err_mismatch: 'كلمات المرور الجديدة غير متطابقة',
  pwd_err_same: 'لا يمكن أن تكون كلمة المرور الجديدة مطابقة للكلمة الحالية',
  pwd_err_unexpected: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  consult_tab_loading: 'جار التحميل...',
  consult_tab_empty: 'ليس لديك طلبات استشارة بعد',
  consult_tab_explore: 'استكشاف المؤسسات',
  consult_tab_cancel: 'إلغاء',
  consult_tab_cancel_confirm: 'هل أنت متأكد من إلغاء طلب الاستشارة هذا؟',
  consult_tab_cancelled: 'تم إلغاء طلب الاستشارة',
  consult_tab_cancel_failed: 'فشل الإلغاء',
  consult_tab_evaluate: 'تقييم',
  consult_tab_view_inst: 'عرض المؤسسة',
  consult_tab_appt_info: 'معلومات الموعد',
  consult_tab_appt_date: 'التاريخ',
  consult_tab_appt_note: 'ملاحظة',
  consult_tab_review_title: 'كتابة تقييم',
  consult_tab_review_rating: 'تقييمك',
  consult_tab_review_comment: 'تعليقك',
  consult_tab_review_comment_ph: 'شارك تجربتك...',
  consult_tab_review_recommend: 'أوصي بهذه المؤسسة',
  consult_tab_review_submit: 'إرسال',
  consult_tab_review_cancel: 'إلغاء',
  consult_tab_review_sent: 'تم إرسال تقييمك وسيُنشر بعد الموافقة',
  consult_tab_review_failed: 'تعذر إرسال التقييم',
  consult_tab_load_failed: 'تعذر تحميل طلبات الاستشارة',
  consult_tab_status_waiting: 'قيد الانتظار',
  consult_tab_status_appointed: 'تم تحديد موعد',
  consult_tab_status_completed: 'مكتمل',
  consult_tab_status_cancelled: 'ملغى',
  consult_tab_status_rejected: 'مرفوض',
  contracts_title: 'عقودي',
  contracts_desc: 'يمكنك عرض العقود التي وافقت عليها وإصداراتها الحالية.',
  contracts_loading: 'جار التحميل...',
  contracts_empty: 'لا توجد عقود بعد',
  contracts_agreed_version: 'الإصدار الذي وافقت عليه',
  contracts_outdated: 'الإصدار الحالي: {{version}} متاح',
  contracts_up_to_date: 'لقد وافقت على الإصدار الحالي',
  contracts_not_agreed: 'لم توافق على هذا العقد بعد',
  contracts_current_version: 'الإصدار الحالي',
  contracts_effective_date: 'تاريخ السريان',
  contracts_view_full: 'عرض المحتوى الكامل',
  contracts_close: 'إغلاق',
  contracts_version_label: 'الإصدار',
  contracts_type_user_terms: 'اتفاقية العضوية والاستخدام',
  contracts_type_user_kvkk: 'اتفاقية موافقة KVKK',
  contracts_type_user_marketing: 'اتفاقية التواصل التسويقي',
  login_email: 'البريد الإلكتروني',
  login_password: 'كلمة المرور',
  login_submit: 'تسجيل الدخول',
  login_logging_in: 'جار تسجيل الدخول...',
  login_error: 'بريد إلكتروني أو كلمة مرور غير صحيحة.',
  login_forgot_password: 'نسيت كلمة المرور؟',
  login_no_account: 'ليس لديك حساب؟',
  login_register: 'إنشاء حساب',
  login_user_title: 'دخول المستخدم',
  login_institution_title: 'دخول المؤسسة',
  login_admin_title: 'دخول المشرف',
};

export default dashboard;
